import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireRole }) {
  const { user } = useAuth();
  const token = localStorage.getItem("sigsaop_token");
  if (!token || !user) return <Navigate to="/login" replace />;
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
